import React, { useEffect, useMemo, useState } from 'react'
import "./CssFiles/calendarViewStatic.css";
import DemoWeekScheduler from './DemoWeekScheduler';
import DemoDayScheduler from './DemoDayScheduler';
import DemoMonthScheduler from './DemoMonthScheduler';
import DemoAgenda from './DemoAgenda';
import { FetchVisitReason, GetappointmentsbyPut, GetDoctorsRequest, Providerlist } from '../../../../api/helper';
import { useSelector } from 'react-redux';
function PatientCalenderView() {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [calendar, setCalendar] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [currentView, setCurrentView] = useState("week");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const profileData = useSelector((state) => state?.cookies?.userDetails);
  const [providerdata, setproviderdata] = useState([]);
  const [visitReasondata, setvisitReasondata] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("");
  const [selectedResource, setSelectedResource] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedReason, setSelectedReason] = useState("");
    const [resourcedata, setresourcedata] = useState([]);
    const [addressData, setaddressData] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [visitstatus, setvisitstatus] = useState([]);
    const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
    const [appointmentType, setappointmentType] = useState([]);
    const [selectedpayment, setselectedpayment] = useState("");
    const [paymentmethoddata, setpaymentmethoddata] = useState([]);

// console.log(appointments,"appointments=-=-=")

const filteredAppointments = appointments.filter(app => {
  if (selectedProvider && app.doctorRequestId?._id !== selectedProvider) return false;
  if (selectedResource && app.appointmentResource !== selectedResource) return false;
  if (selectedLocation && app.serviceLocationId?._id !== selectedLocation) return false;
  if (selectedReason && app.visitReason?._id !== selectedReason) return false;
  if (selectedStatus && app.appointmentStatus?._id !== selectedStatus) return false;
  if (selectedAppointmentType && app.deliveryMode?._id !== selectedAppointmentType) return false;
  // if (selectedPayment && app.paymentSource !== selectedPayment) return false;
  return true;
});


    const getAppointmentresponse = async () => {
    try {
      const response = await GetappointmentsbyPut({
        patientId: profileData._id,
      });
      setAppointments(response.data.data.appointments);
    } catch (error) {
      console.log(error, "====>error");
    }
  };


  // 🔹 Static mock data

  const GetVisitReason = async () => {
    const response = await FetchVisitReason(`?id=${profileData?._id}`);
    setvisitReasondata(response?.data?.data);
  };
      const GetProvider = async () => {
      // ?page=${page}&limit=1000`
      try {
        const response = await Providerlist();
        setproviderdata(response?.data?.data?.data);
      } catch (error) {
        console.log(error);
      }
    };
    useEffect(() => {
      GetProvider()
      // FetchDoctorrequest();
      GetVisitReason();
    getAppointmentresponse();
  }, []);



   const handleDateClick = (year, month, day) => {
    const clickedDate = new Date(year, month, day);
    clickedDate.setHours(0, 0, 0, 0);

    if (!selectedDate || (selectedDate && selectedEndDate)) {
      setSelectedDate(clickedDate);
      setSelectedEndDate(null);
    } else if (
      selectedDate &&
      !selectedEndDate &&
      clickedDate >= selectedDate
    ) {
      setSelectedEndDate(clickedDate);
    } else {
      setSelectedDate(clickedDate);
      setSelectedEndDate(null);
    }
  };

   useEffect(() => {
      generateMiniCalendar(currentMonth.getFullYear(), currentMonth.getMonth());
    }, [currentMonth]);

   const generateMiniCalendar = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();

    let days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(null);
    }

    for (let d = 1; d <= lastDate; d++) {
      days.push(d);
    }

    setCalendar(days);
  };
  const goToPreviousMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    setCurrentMonth(newMonth);
  };

  const goToNextMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    setCurrentMonth(newMonth);
  };
    const isSameDate = (date1, date2) => {
    if (!date1 || !date2) return false;
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };
    const generateCalendarDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay?.getDate();
    const startingDayOfWeek = firstDay?.getDay();

    const days = [];

    // Add previous month's days
    const prevMonthLastDay = new Date(year, month, 0).getDate();
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      days.push({
        day: prevMonthLastDay - i,
        isCurrentMonth: false,
        isPrevMonth: true,
      });
    }

    // Add current month's days
    for (let day = 1; day <= daysInMonth; day++) {
      days.push({
        day: day,
        isCurrentMonth: true,
        isPrevMonth: false,
      });
    }

    // Add next month's days to fill the grid (total 42 cells = 6 rows × 7 days)
    const totalCells = 42;
    let nextMonthDay = 1;
    while (days.length < totalCells) {
      days.push({
        day: nextMonthDay++,
        isCurrentMonth: false,
        isPrevMonth: false,
      });
    }

    return days;
  };

  const calendarDays = generateCalendarDays();
    const handleDateChange = (direction) => {
    const newDate = new Date(currentDate);

    if (direction === "prev") {
      if (currentView === "day") {
        newDate.setDate(newDate.getDate() - 1);
      } else if (currentView === "week") {
        newDate.setDate(newDate.getDate() - 7);
      } else if (currentView === "month") {
        newDate.setMonth(newDate.getMonth() - 1);
      }
    } else if (direction === "next") {
      if (currentView === "day") {
        newDate.setDate(newDate.getDate() + 1);
      } else if (currentView === "week") {
        newDate.setDate(newDate.getDate() + 7);
      } else if (currentView === "month") {
        newDate.setMonth(newDate.getMonth() + 1);
      }
    } else if (direction === "today") {
      newDate.setTime(new Date().getTime());
    }

    setCurrentDate(newDate);
  };

  
const uniqueById = (arr, keyPath) => {
  const seen = new Set();
  return arr.filter((item) => {
    const key = keyPath.split(".").reduce((acc, k) => acc?.[k], item);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const providerOptions = useMemo(() => 
  uniqueById(appointments, "doctorRequestId._id").map(app => ({
    _id: app.doctorRequestId?._id,
    name: `${app.doctorRequestId?.firstName || ""} ${app.doctorRequestId?.lastName || ""}`
  }))
, [appointments]);

const resourceOptions = useMemo(() => 
  [...new Set(appointments.map(app => app.appointmentResource).filter(Boolean))]
  .map(id => ({ _id: id, name: id }))
, [appointments]);

const locationOptions = useMemo(() => 
  uniqueById(appointments, "serviceLocationId._id").map(app => ({
    _id: app.serviceLocationId?._id,
    name: app.serviceLocationId?.name
  }))
, [appointments]);

const reasonOptions = useMemo(() => 
  uniqueById(appointments, "visitReason._id").map(app => ({
    _id: app.visitReason?._id,
    name: app.visitReason?.visitReason
  }))
, [appointments]);

const statusOptions = useMemo(() => 
  uniqueById(appointments, "appointmentStatus._id").map(app => ({
    _id: app.appointmentStatus?._id,
    name: app.appointmentStatus?.name
  }))
, [appointments]);

const typeOptions = useMemo(() => 
  uniqueById(appointments, "deliveryMode._id").map(app => ({
    _id: app.deliveryMode?._id,
    name: app.deliveryMode?.name
  }))
, [appointments]);

const paymentOptions = useMemo(() => 
  [...new Set(appointments.map(app => app.paymentSource).filter(Boolean))]
  .map(name => ({ _id: name, name }))
, [appointments]);
  return (

    <>
      <div className="cvs-container">
        {/* Header */}
        <div className="cvs-header">
          <div className="cvs-header-left">
            <div className="cvs-view-toggle" role="tablist" aria-label="Calendar view">
              {["week", "day", "month", "agenda"].map((view) => (
                <button
                  key={view}
                  onClick={() => setCurrentView(view)}
                  className={`cvs-btn cvs-btn--ghost ${currentView === view ? "cvs-btn--active" : ""
                    }`}
                >
                  {view.charAt(0).toUpperCase() + view.slice(1)}
                </button>
              ))}
            </div>

            <div className="cvs-nav">
              <button className="cvs-btn cvs-btn--ghost"
              onClick={() => handleDateChange("prev")}
              >Prev</button>
              <button className="cvs-btn cvs-btn--today"
              onClick={() => handleDateChange("today")}
              >Today</button>
              <button className="cvs-btn cvs-btn--ghost"
                onClick={() => handleDateChange("next")}
              >Next</button>
            </div>

            <div className="cvs-date-range" id="date-range">
             {currentDate.toDateString()}
            </div>
          </div>

          <div className="cvs-header-right">
            <button className="cvs-btn cvs-btn--primary">+ Create Appointment</button>
            <button className="cvs-btn cvs-btn--primary cvs-btn--outline">Calendar Synch</button>
            <button className="cvs-btn cvs-btn--primary cvs-btn--outline">Settings</button>
          </div>
        </div>

        {/* Search */}
        <div className="cvs-search">
          <input type="text" className="cvs-input" placeholder="Search appointments..." />
        </div>


        <div className="cvs-layout">
        
          <aside className="cvs-sidebar">
<div className="mini-calendar-container_CalendarView">
            <div className="mini-calendar-container">
              <div className="calendar-header_two">
                <button className="nav-button" onClick={goToPreviousMonth}>
                  &lt;
                </button>
                <span className="month-label">
                  {currentMonth.toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                  })}
                </span>
                <button className="nav-button" onClick={goToNextMonth}>
                  &gt;
                </button>
              </div>

              <table className="calendar-table">
                <thead>
                  <tr>
                    {["S", "M", "T", "W", "T", "F", "S"].map((day) => (
                      <th key={day}>{day}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: Math.ceil(calendar.length / 7) }).map(
                    (_, weekIndex) => (
                      <tr key={weekIndex}>
                        {calendar
                          .slice(weekIndex * 7, weekIndex * 7 + 7)
                          .map((day, idx) => {
                            const fullDate =
                              day &&
                              new Date(
                                currentMonth.getFullYear(),
                                currentMonth.getMonth(),
                                day
                              );
                            const isToday =
                              fullDate && isSameDate(fullDate, new Date());
                            const isStart =
                              fullDate &&
                              selectedDate &&
                              isSameDate(fullDate, selectedDate);
                            const isEnd =
                              fullDate &&
                              selectedEndDate &&
                              isSameDate(fullDate, selectedEndDate);

                            return (
                              <td
                                key={idx}
                                className={`day-cell
                        ${isToday ? "today_date" : ""}
                        ${isStart ? "selected-start" : ""}
                        ${isEnd ? "selected-end" : ""}
                      `}
                                onClick={() =>
                                  day &&
                                  handleDateClick(
                                    currentMonth.getFullYear(),
                                    currentMonth.getMonth(),
                                    day
                                  )
                                }
                              >
                                {day || ""}
                              </td>
                            );
                          })}
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>           
          </div>

            <div className="cvs-card">
              
             <div className="calendar-filters_CalendarView">
          <div className="form-group_CalendarView">
  <label>Provider:</label>
  <select value={selectedProvider} onChange={e => setSelectedProvider(e.target.value)}>
    <option value="">-- Select Provider --</option>
    {providerOptions.map(p => (
      <option key={p._id} value={p._id}>{p.name}</option>
    ))}
  </select>
</div>


              {/* <div className="form-group_CalendarView">
                <label>Resource:</label>
                <select
                  value={selectedResource}
                  onChange={(e) => setSelectedResource(e.target.value)}
                >
                  <option value="">-- Select Resource --</option>
                  {resourcedata.map((item) => {
                    return (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>
              </div> */}
              {/* <div className="form-group_CalendarView">
                <label>Location:</label>
                <select
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <option value="">-- Select Location --</option>
                  {addressData.map((item) => {
                    return (
                      <option key={item._id} value={item?._id}>
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
              </div> */}
              {/* <div className="form-group_CalendarView">
  <label>Resource:</label>
  <select value={selectedResource} onChange={e => setSelectedResource(e.target.value)}>
    <option value="">-- Select Resource --</option>
    {resourceOptions.map(r => (
      <option key={r._id} value={r._id}>{r.name}</option>
    ))}
  </select>
</div> */}

<div className="form-group_CalendarView">
  <label>Location:</label>
  <select value={selectedLocation} onChange={e => setSelectedLocation(e.target.value)}>
    <option value="">-- Select Location --</option>
    {locationOptions.map(l => (
      <option key={l._id} value={l._id}>{l.name}</option>
    ))}
  </select>
</div>

<div className="form-group_CalendarView">
  <label>Reason:</label>
  <select value={selectedReason} onChange={e => setSelectedReason(e.target.value)}>
    <option value="">-- Select Reason --</option>
    {reasonOptions.map(r => (
      <option key={r._id} value={r._id}>{r.name}</option>
    ))}
  </select>
</div>

<div className="form-group_CalendarView">
  <label>Status:</label>
  <select value={selectedStatus} onChange={e => setSelectedStatus(e.target.value)}>
    <option value="">-- Select Status --</option>
    {statusOptions.map(s => (
      <option key={s._id} value={s._id}>{s.name}</option>
    ))}
  </select>
</div>

<div className="form-group_CalendarView">
  <label>Appointment Type:</label>
  <select value={selectedAppointmentType} onChange={e => setSelectedAppointmentType(e.target.value)}>
    <option value="">-- Select Type --</option>
    {typeOptions.map(t => (
      <option key={t._id} value={t._id}>{t.name}</option>
    ))}
  </select>
</div>

{/* <div className="form-group_CalendarView">
  <label>Payment Method:</label>
  <select value={selectedPayment} onChange={e => setSelectedPayment(e.target.value)}>
    <option value="">-- Select Method --</option>
    {paymentOptions.map(p => (
      <option key={p._id} value={p._id}>{p.name}</option>
    ))}
  </select>
</div> */}

            </div>

            <div id="selectedMiniDay">
              {selectedDate
                ? `Selected Date: ${selectedDate.toLocaleDateString("en-GB")}`
                : "No Date Selected"}
            </div>

            <ul id="miniEventList">
              {selectedDate && filteredAppointments.length > 0 ? (
                filteredAppointments.map((app, index) => (
                  <li
                    key={index}
                    onClick={() => alert(`Edit Appointment ${app._id}`)}
                  >
                    {app.startTime} - {app.Duration} |{" "}
                    {app.patientRequestId?.firstName} |{" "}
                    {app.doctorRequestId?.firstName}
                  </li>
                ))
              ) : (
                <li>No appointments for this date.</li>
              )}
            </ul>
            </div>
          </aside>

          {/* Right column – view */}
          <main >
            {currentView === "week" && (            
                <DemoWeekScheduler 
                 currentDate={currentDate}
                setCurrentDate={setCurrentDate}
                appointments={appointments}
              
                />
            )}
            {currentView === "day" && (
              <DemoDayScheduler 
               currentDate={currentDate}
                 appointments={appointments}
               />
            )}
            {currentView === "month" && (
              <DemoMonthScheduler 
              calendarDays={calendarDays}
                appointments={appointments}
                currentDate={currentDate}
                // setSelectedSlot={setSelectedSlot}
                // setShowAppointmentPanel={setShowAppointmentPanel}
              />
            )}
            {currentView === "agenda" && (
              <DemoAgenda />
            )}
          </main>
        </div>
      </div>

    </>



  );
}

export default PatientCalenderView
